export const Categories = Object.freeze({
  ContentFeed: 'AdInventory',
  MarketContentFeed: 'MallInventory',
  MediaLogo: 'AdElementLogo',
  Media: 'AdElement',
  MediaSquare: 'AdElementSquare',
  MediaStraight: 'AdElementStraight',
});

export default class Asset {
  constructor(data) {
    this.id = '';
    this.name = '';
    this.url = '';
    this.base64 = '';
    this.size = 0;
    this.mime = '';
    this.category = '';

    this.initialize(data);
  }

  initialize(data = {}) {
    this.id = data.id ?? this.id;
    this.name = data.fileName ?? data.name ?? this.name;
    this.url = data.fileUrl ?? data.url ?? this.url;
    this.base64 = data.fileContent ?? data.base64 ?? this.base64;
    this.size = data.fileSize ?? data.size ?? this.size;
    this.mime = data.fileType ?? data.mime ?? this.mime;
    this.category = data.category ?? this.category;
  }
}
